import { RerouteService } from "@/common/api.service";
import {
  GET_CHECKER_LIST,
  UPDATE_CHECKER,
} from "./actions.type";
import { SET_ERROR, ISLOADING } from "./mutations.type";

const state = {
  errors: null,
  checker_list: {},
};

const getters = {
  checker_list(state) {
    return state.checker_list;
  },
};

const actions = {
    async [GET_CHECKER_LIST](context, payload) {
        RerouteService.init();
        RerouteService.setHeader();
        context.commit(ISLOADING, true);
        return new Promise((resolve) => {
        RerouteService.get(`checker/list${payload}`)
            .then((data) => {
            context.commit(ISLOADING, false);
            context.commit("setCheckerList", data);
            resolve(data);
            })
            .catch(({ response }) => {
            context.commit(ISLOADING, false);
            context.commit(SET_ERROR, response);
            resolve(response);
            });
        });
    },

    // Update Checker Status
    async [UPDATE_CHECKER](context, payload) {
        RerouteService.init();
        RerouteService.setHeader();
        return new Promise((resolve) => {
        RerouteService.put(`checker/update/${payload.id}`, payload)
            .then((data) => {
            context.commit(ISLOADING, false);
            resolve(data);
            })
            .catch(({ response }) => {
            context.commit(ISLOADING, false);
            resolve(response);
            });
        });
    },              
};

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [ISLOADING](state, loading) {
    state.isLoading = loading;
  },
  setCheckerList(state, data) {
    state.checker_list = data;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
